//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'repayDetailDialog',
  props: [
    'value',
    'themeType',
    'period',
    'actualAmount',
    'isBtnDisabled',
    'hasReward'
  ],
  data() {
    return {
      show: this.value
    }
  },
  computed: {
    text() {
      return `共计￥${this.actualAmount}，${
        this.hasReward ? '还款奖励生效需全部还款成功，' : ''
      }请确保银行卡余额充足。`
    }
  },
  watch: {
    show() {
      this.$emit('input', this.show)
    },
    value() {
      this.show = this.value
    }
  }
}
